export default __webpack_public_path__ + "static/media/7.09c94c9a.jpg";